import { useMutation, useQueryClient } from 'react-query'
import { QUERY_KEYS } from 'src/constants'

import { mediaEntityUploadService } from 'src/services/media-entity-upload.service'
import { mediaListService } from 'src/services/media-list.service'
import { ICreateMediaForm } from 'src/types'
import { useNotification } from '../common'

export const useCreateMedia = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (dto: ICreateMediaForm) => {
      const media = await mediaEntityUploadService.uploadMedia(dto.media)

      return mediaListService.createMedia({ media })
    },
    {
      onSuccess(data) {
        if (!data) {
          return
        }
        

        queryClient.invalidateQueries([QUERY_KEYS.MEDIA_LIST])
      },
    },
  )
}
